
/* Dojo Eats checkout recovery. Styling is untouched. */
(function () {
  'use strict';

  if (window.__dojoCheckoutRecoveryInstalled) return;
  window.__dojoCheckoutRecoveryInstalled = true;

  function rootPath() {
    return window.Shopify?.routes?.root || '/';
  }

  function route(path) {
    return rootPath().replace(/\/?$/, '/') + String(path || '').replace(/^\//, '');
  }

  function getTarget(event) {
    return event.target instanceof Element
      ? event.target
      : event.target?.parentElement;
  }

  function findProductForm(button) {
    const ownForm = button.form || button.closest('form');

    if (ownForm?.querySelector('[name="id"]')) return ownForm;

    const section = button.closest(
      '.shopify-section, section, [id^="shopify-section"]'
    );

    return section?.querySelector(
      'form[action*="/cart/add"]'
    ) || null;
  }

  function isCheckoutControl(element) {
    if (!element) return false;

    const text = [
      element.name,
      element.value,
      element.getAttribute('aria-label'),
      element.textContent
    ].filter(Boolean).join(' ').toLowerCase();

    const cartContext = element.closest(
      '#CartDrawer, #cart-drawer, [id*="CartDrawer"], ' +
      'cart-drawer, cart-drawer-component, .cart-drawer, ' +
      '.drawer--cart, [data-cart-drawer]'
    );

    const cartPage =
      location.pathname.replace(/\/+$/, '').endsWith('/cart');

    return element.matches('a[href*="/checkout"]') ||
      (element.name === 'checkout' && (cartContext || cartPage)) ||
      (!!cartContext && /check out|checkout/.test(text));
  }

  async function handleBuyNow(button) {
    const form = findProductForm(button);

    if (!form || !form.querySelector('[name="id"]')) {
      console.error('[Dojo] Product form or variant ID not found.', button);
      alert('Unable to start checkout. Please add the product to your cart first.');
      return;
    }

    const data = new FormData(form);

    if (!data.get('id')) {
      alert('Please select a product option first.');
      return;
    }

    if (!data.get('quantity')) data.set('quantity', '1');

    button.setAttribute('aria-busy', 'true');
    if ('disabled' in button) button.disabled = true;

    try {
      const response = await fetch(route('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: data
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result.description || 'Could not add product to cart.');
      }

      location.assign(route('checkout'));
    } catch (error) {
      console.error('[Dojo] Buy Now failed:', error);
      button.removeAttribute('aria-busy');
      if ('disabled' in button) button.disabled = false;
      alert(error.message || 'Checkout could not be started.');
    }
  }

  document.addEventListener('click', function (event) {
    const target = getTarget(event);
    if (!target) return;

    if (target.closest('.rzp-sidecart-checkout')) return;
    
    const control = target.closest(
      'a[href*="/checkout"], button[name="checkout"], ' +
      'input[name="checkout"], #CartDrawer button, #cart-drawer button, ' +
      '[id*="CartDrawer"] button, cart-drawer button, ' +
      'cart-drawer-component button, .cart-drawer button'
    );

    if (control && isCheckoutControl(control)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      location.assign(route('checkout'));
      return;
    }

    const buyButton = target.closest(
      '[data-buy-now], [data-dojo-buy-now], ' +
      '.dojo-product-purchase-v2__buy-button, ' +
      '.dojo-product-hero__buy-now'
    );

    if (!buyButton || buyButton.disabled) return;

    const form = findProductForm(buyButton);
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    handleBuyNow(buyButton);
  }, true);

  console.info('[Dojo] Checkout recovery script loaded.');
  
  // Target the actual Shopify cart checkout button.
  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element
      ? event.target
      : event.target?.parentElement;

    const button = target?.closest(
      '#checkout.cart__checkout-button[name="checkout"][form="cart-form"]'
    );

    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const cartForm = document.getElementById('cart-form');

    if (!cartForm) {
      console.error('[Dojo] Checkout clicked, but #cart-form was not found.');
      alert('Checkout could not start because the cart form is missing.');
      return;
    }

    window.location.assign(
      (window.Shopify?.routes?.root || '/') + 'checkout'
    );
  }, true);

})();
